import { Controller } from '@hotwired/stimulus'
import { notifyError } from '../lib/toast'

export default class extends Controller {
  static targets = ['backdrop', 'image', 'frame', 'link', 'title']

  connect() {
    this.handleKeydown = this.handleKeydown.bind(this)
  }

  open(event) {
    if (event?.target?.closest('[data-receipt-modal-ignore]')) return
    if (event?.target?.closest('[data-receipt-modal-remove-url]')) return
    const target = event.currentTarget
    const url = target?.dataset?.receiptModalUrl
    if (!url) return

    const filename = target?.dataset?.receiptModalFilename || 'Receipt'
    const contentType = target?.dataset?.receiptModalContentType || ''

    this.titleTarget.textContent = filename
    this.resetMedia()

    if (contentType.includes('pdf')) {
      this.frameTarget.src = url
      this.frameTarget.classList.remove('hidden')
    } else if (contentType.startsWith('image/')) {
      this.imageTarget.src = url
      this.imageTarget.classList.remove('hidden')
    } else {
      this.linkTarget.href = url
      this.linkTarget.classList.remove('hidden')
    }

    this.backdropTarget.classList.remove('hidden')
    this.backdropTarget.classList.add('flex')
    document.body.classList.add('overflow-hidden')
    window.addEventListener('keydown', this.handleKeydown)
  }

  close() {
    this.backdropTarget.classList.add('hidden')
    this.backdropTarget.classList.remove('flex')
    this.resetMedia()
    document.body.classList.remove('overflow-hidden')
    window.removeEventListener('keydown', this.handleKeydown)
  }

  backdropClose(event) {
    if (event.target !== this.backdropTarget) return
    this.close()
  }

  handleKeydown(event) {
    if (event.key === 'Escape') {
      this.close()
    }
  }

  resetMedia() {
    this.imageTarget.classList.add('hidden')
    this.frameTarget.classList.add('hidden')
    this.linkTarget.classList.add('hidden')
    this.imageTarget.src = ''
    this.frameTarget.src = ''
    this.linkTarget.removeAttribute('href')
  }

  async remove(event) {
    event.preventDefault()
    event.stopPropagation()

    const button = event.currentTarget
    const url = button?.dataset?.receiptModalRemoveUrl
    if (!url) return

    const confirmed = window.confirm('Remove this receipt?')
    if (!confirmed) return

    const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
    const response = await fetch(url, {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'X-CSRF-Token': token || '',
      },
      credentials: 'same-origin',
    })

    if (!response.ok) {
      notifyError('Unable to remove receipt.')
      return
    }

    const payload = await response.json().catch(() => null)
    if (payload?.receipts_html) {
      document.dispatchEvent(
        new CustomEvent('receipts:updated', { detail: { html: payload.receipts_html } }),
      )
    }
  }
}
